import { Routes } from '@angular/router';
import { FindvkeComponent } from '@app/views/vertriebscockpit/findvkebase/findvke/findvke.component';
import { FindvkemaklerComponent } from '@app/views/vertriebscockpit/findvkebase/findvkemakler/findvkemakler.component';
import { KfzSchnellrechnerComponent } from '@app/views/vertriebscockpit/schnellrechner/kfz-schnellrechner.component';
import { AuthGuard } from 'app/api/core/auth/guard/auth.guard';
import { ProduktComponent } from 'app/views/offert/produkt/produkt.component';
import { StartOffertComponent } from 'app/views/offert/start-offert/start-offert.component';
import { StartComponent } from 'app/views/vertriebscockpit/start/start.component';
import { GsmAbortGuard } from './api/core/auth/guard/gsm-abort.guard';
import { GsmNachbringenAbortGuard } from './api/core/auth/guard/gsm-nachbringen-abort.guard';
import { GsmGuard } from './api/core/auth/guard/gsm.guard';
import { ConfirmDeactivateGuard } from './api/core/deactivate.guard';
import { ProduktbausteinDetailComponent } from './views/offert/produktbaustein/produktbaustein-detail.component';
import { ChecklistItemNachbringenComponent } from './views/vertriebscockpit/gsm/checklist-item-nachbringen/checklist-item-nachbringen.component';
import { SchadenBearbeitenComponent } from './views/vertriebscockpit/gsm/schaden-melden/schaden-bearbeiten.component';
import { SchadenMeldenComponent } from './views/vertriebscockpit/gsm/schaden-melden/schaden-melden.component';
import { SchadenUebersichtComponent } from './views/vertriebscockpit/gsm/schadenuebersicht/schadenuebersicht.component';
import { OfferteAndAntraegeComponent } from './views/vertriebscockpit/offerteantraege/offerteantraege.component';
import { RisikouebersichtComponent } from './views/vertriebscockpit/risikouebersicht/risikouebersicht.component';
import { TermineComponent } from './views/vertriebscockpit/termine/termine.component';

export const MATERIAL_APP_ROUTES: Routes = [
  {
    path:          'offert',
    loadComponent: () => import('@app/shared/components/main-layout/main-layout.component').then(mod => mod.MainLayoutComponent),
    canActivate:   [AuthGuard],
    children:      [
      {
        path:          'konfiguration',
        loadComponent: () => import('./views/offert/start-offert/start-offert.component').then(mod => mod.StartOffertComponent)
      },
      {
        path:          'konfiguration/produkt',
        loadComponent: () => import('./views/offert/produkt/produkt.component').then(mod => mod.ProduktComponent)
      },
      {
        path:          'konfiguration/produkt/:veid',
        loadComponent: () => import('./views/offert/produkt/produkt.component').then(mod => mod.ProduktComponent),
        data:          {
          breadcrumbs: [
            {
              component: StartOffertComponent,
              url:       '/offert/konfiguration'
            },
            {
              component: ProduktComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'konfiguration/produkt/:veid/:posid',
        loadComponent: () => import('./views/offert/produktbaustein/produktbaustein-detail.component').then(mod => mod.ProduktbausteinDetailComponent),
        data:          {
          breadcrumbs: [
            {
              component: StartOffertComponent,
              url:       '/offert/konfiguration'
            },
            {
              component: ProduktComponent,
              url:       '/offert/produkt/:veid'
            },
            {
              component: ProduktbausteinDetailComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'konfiguration/:vid',
        loadComponent: () => import('./views/offert/start-offert/start-offert.component').then(mod => mod.StartOffertComponent)
      },
      {
        path:          'konfiguration/:vid/:pid',
        loadComponent: () => import('./views/offert/start-offert/start-offert.component').then(mod => mod.StartOffertComponent)
      },
      {
        path:          'kunden-info',
        loadComponent: () => import('./views/offert/kunden-info/kunden-info.component').then(mod => mod.KundenInfoComponent)
      },
      {
        path:          'objekte',
        loadComponent: () => import('./views/offert/objekte/objekte.component').then(mod => mod.ObjekteComponent)
      },
      {
        path:          'erstellen',
        loadComponent: () => import('./views/offert/erstellen/offert-erstellung.component').then(mod => mod.OffertErstellungComponent)
      },
      {
        path:          'antrag',
        loadComponent: () => import('./views/offert/antrag/offert-antrag.component').then(mod => mod.OffertAntragComponent)
      }
    ]
  },
  {
    path:          '',
    loadComponent: () => import('@app/shared/components/main-layout/main-layout.component').then(mod => mod.MainLayoutComponent),
    canActivate:   [
      AuthGuard
    ],
    children:      [
      {
        path:          '',
        loadComponent: () => import('./views/vertriebscockpit/start/start.component').then(mod => mod.StartComponent)
      },
      {
        path:          'riskinereturn/:externalId',
        loadComponent: () => import('./views/vertriebscockpit/start/start.component').then(mod => mod.StartComponent)
      },
      {
        path:          'vke-finden',
        loadComponent: () => import('./views/vertriebscockpit/findvkebase/findvke/findvke.component').then(mod => mod.FindvkeComponent),
        data:          {
          breadcrumbs: [
            {
              component: StartComponent,
              url:       ''
            },
            {
              component: FindvkeComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'maklerprodukte',
        loadComponent: () => import('./views/vertriebscockpit/findvkebase/findvkemakler/findvkemakler.component').then(mod => mod.FindvkemaklerComponent),
        data:          {
          breadcrumbs: [
            {
              component: StartComponent,
              url:       ''
            },
            {
              component: FindvkemaklerComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'schnellrechner/:schnellrechnerId/:vmsId',
        loadComponent: () => import('./views/vertriebscockpit/schnellrechner/kfz-schnellrechner.component').then(mod => mod.KfzSchnellrechnerComponent),
        data:          {
          breadcrumbs: [
            {
              component: StartComponent,
              url:       ''
            }, // TODO add produkte?
            {
              component: KfzSchnellrechnerComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'risikouebersicht',
        loadComponent: () => import('./views/vertriebscockpit/risikouebersicht/risikouebersicht.component').then(mod => mod.RisikouebersichtComponent),
        canDeactivate: [ConfirmDeactivateGuard],
        data:          {
          breadcrumbs: [
            {
              component: StartComponent,
              url:       ''
            },
            {
              component: RisikouebersichtComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'risikouebersicht/:kundenId',
        loadComponent: () => import('./views/vertriebscockpit/risikouebersicht/risikouebersicht.component').then(mod => mod.RisikouebersichtComponent),
        canDeactivate: [ConfirmDeactivateGuard],
        data:          {
          breadcrumbs: [
            {
              component: StartComponent,
              url:       ''
            },
            {
              component: RisikouebersichtComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'offerte-antraege',
        loadComponent: () => import('./views/vertriebscockpit/offerteantraege/offerteantraege.component').then(mod => mod.OfferteAndAntraegeComponent),
        data:          {
          breadcrumbs: [
            {
              component: StartComponent,
              url:       ''
            },
            {
              component: OfferteAndAntraegeComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'schaden/uebersicht',
        loadComponent: () => import('./views/vertriebscockpit/gsm/schadenuebersicht/schadenuebersicht.component').then(mod => mod.SchadenUebersichtComponent),
        canActivate:   [GsmGuard],
        canDeactivate: [ConfirmDeactivateGuard],
        data:          {
          breadcrumbs: [
            {
              component: StartComponent,
              url:       ''
            },
            {
              component: SchadenUebersichtComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'schaden/uebersicht/:schadennummer',
        loadComponent: () => import('./views/vertriebscockpit/gsm/schadenuebersicht/schadenuebersicht.component').then(mod => mod.SchadenUebersichtComponent),
        canActivate:   [GsmGuard],
        canDeactivate: [ConfirmDeactivateGuard],
        data:          {
          breadcrumbs: [
            {
              component: StartComponent,
              url:       ''
            },
            {
              component: SchadenUebersichtComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'schaden/uebersicht/:schadennummer',
        loadComponent: () => import('./views/vertriebscockpit/gsm/schadenuebersicht/schadenuebersicht.component').then(mod => mod.SchadenUebersichtComponent),
        canActivate:   [GsmGuard],
        canDeactivate: [ConfirmDeactivateGuard],
        data:          {
          breadcrumbs: [
            {
              component: StartComponent,
              url:       ''
            },
            {
              component: SchadenUebersichtComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'schaden/uebersicht/:kundenId',
        loadComponent: () => import('./views/vertriebscockpit/gsm/schadenuebersicht/schadenuebersicht.component').then(mod => mod.SchadenUebersichtComponent),
        canActivate:   [GsmGuard],
        data:          {
          breadcrumbs: [
            {
              component: StartComponent,
              url:       ''
            },
            {
              component: SchadenUebersichtComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'schaden/melden',
        loadComponent: () => import('./views/vertriebscockpit/gsm/schaden-melden/schaden-melden.component').then(mod => mod.SchadenMeldenComponent),
        canActivate:   [GsmGuard],
        canDeactivate: [GsmAbortGuard],
        data:          {
          breadcrumbs: [
            {
              component: StartComponent,
              url:       ''
            },
            {
              component: SchadenUebersichtComponent,
              url:       '/schaden/uebersicht'
            },
            {
              component: SchadenMeldenComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'schaden/melden/:polizzennummer',
        loadComponent: () => import('./views/vertriebscockpit/gsm/schaden-melden/schaden-melden.component').then(mod => mod.SchadenMeldenComponent),
        canActivate:   [GsmGuard],
        canDeactivate: [GsmAbortGuard],
        data:          {
          breadcrumbs: [
            {
              component: StartComponent,
              url:       ''
            },
            {
              component: SchadenUebersichtComponent,
              url:       '/schaden/uebersicht'
            },
            {
              component: SchadenMeldenComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'schaden/melden/:polizzennummer/:schadendatum',
        loadComponent: () => import('./views/vertriebscockpit/gsm/schaden-melden/schaden-melden.component').then(mod => mod.SchadenMeldenComponent),
        canActivate:   [GsmGuard],
        canDeactivate: [GsmAbortGuard],
        data:          {
          breadcrumbs: [
            {
              component: StartComponent,
              url:       ''
            },
            {
              component: SchadenUebersichtComponent,
              url:       '/schaden/uebersicht'
            },
            {
              component: SchadenMeldenComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'schaden/bearbeiten/:processInstanceId',
        loadComponent: () => import('./views/vertriebscockpit/gsm/schaden-melden/schaden-bearbeiten.component').then(mod => mod.SchadenBearbeitenComponent),
        canActivate:   [GsmGuard],
        canDeactivate: [GsmAbortGuard],
        data:          {
          breadcrumbs: [
            {
              component: StartComponent,
              url:       ''
            },
            {
              component: SchadenUebersichtComponent,
              url:       '/schaden/uebersicht'
            },
            {
              component: SchadenBearbeitenComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'checklistitem/nachbringen/:schadennummer',
        loadComponent: () => import('./views/vertriebscockpit/gsm/checklist-item-nachbringen/checklist-item-nachbringen.component').then(mod => mod.ChecklistItemNachbringenComponent),
        canActivate:   [GsmGuard],
        canDeactivate: [GsmNachbringenAbortGuard],
        data:          {
          breadcrumbs: [
            {
              component: StartComponent,
              url:       ''
            },
            {
              component: SchadenUebersichtComponent,
              url:       '/schaden/uebersicht'
            },
            {
              component: ChecklistItemNachbringenComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'termine',
        loadComponent: () => import('./views/vertriebscockpit/termine/termine.component').then(mod => mod.TermineComponent),
        data:          {
          breadcrumbs: [
            {
              component: StartComponent,
              url:       ''
            },
            {
              component: TermineComponent,
              url:       '#'
            }
          ]
        }
      },
      {
        path:          'kunde/:kundenId',
        loadComponent: () => import('./views/vertriebscockpit/start/start.component').then(mod => mod.StartComponent)
      }
    ]
  },
  {
    path:          'login',
    loadComponent: () => import('./views/login/login.component').then(mod => mod.LoginComponent)
  },
  {
    path:          'info',
    loadComponent: () => import('./shared/components/layout/layout.component').then(mod => mod.LayoutComponent),
    children:      [
      {
        path:          '',
        loadComponent: () => import('./views/info/info.component').then(mod => mod.InfoComponent)
      },
      {
        path:          ':error',
        loadComponent: () => import('./views/info/info.component').then(mod => mod.InfoComponent)
      },
      {
        path:          ':error/:text',
        loadComponent: () => import('./views/info/info.component').then(mod => mod.InfoComponent)
      }
    ]
  },
  {
    path:          '**',
    loadComponent: () => import('./shared/components/layout/layout.component').then(mod => mod.LayoutComponent)
  }
];
